var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customizer-tmall-wishlist"
  }, [_c('div', {
    staticClass: "customizer-tmall-wishlist-notification"
  }, [_c('div', {
    staticClass: "customizer-tmall-wishlist-notification-text"
  }, [_vm._v(_vm._s(_vm.textMessage))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }